import { render, staticRenderFns } from "./GeRen.vue?vue&type=template&id=d5b987a6&scoped=true"
import script from "./GeRen.vue?vue&type=script&setup=true&lang=js"
export * from "./GeRen.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GeRen.vue?vue&type=style&index=0&id=d5b987a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b987a6",
  null
  
)

export default component.exports